import { isInStorybook } from './is-in-storybook';

/** Toggle scroll locking on HTML and body, except when in Storybook */
export function toggleScrollLock(shouldLockScroll: boolean) {
	if (isInStorybook()) {
		return;
	}

	document.documentElement.classList.toggle('zds-overflow-hidden', shouldLockScroll);
	document.body.classList.toggle('zds-overflow-hidden', shouldLockScroll);
}
